import React from "react";
import BookingReportList from "./BookingReportList";
import DeliveryReportList from "./DeliveryReportList";

const AllBookingsDeliveries = () => {
  return (
    <div className="container">
      <div className="section-one">
        <div className="box-row">
          {/* Booking Reports */}
          <div className="box-wrap">
            <div className="box-head">
              <span>Booking Reports</span>
            </div>
            <div style={{ paddingRight: "0rem" }}>
              <BookingReportList />
            </div>
          </div>

          {/* Delivery Reports */}
          <div className="box-wrap">
            <div className="box-head">
              <span>Delivery Reports</span>
            </div>
            <div style={{ paddingRight: "0rem" }}>
              <DeliveryReportList />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllBookingsDeliveries;
